import { configureStore } from "@reduxjs/toolkit";
import { useSelector, useDispatch } from "react-redux";
import { userSlice } from "../features";

const reducer = {
	userData: userSlice.reducer,
}

export const store = configureStore({
	reducer: reducer,
	devTools: true,
});

export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;